@for (customer of customers(); track customer.idktostamm) {
  <div class="customer-detail" data-testid="kundenabfrage-customer-detail">
    <soft-kundeninfo-leiste
      class="customer-detail-wide"
      [idktostamm]="customer.idktostamm"
      [alwaysExpanded]="true"
    />
    <soft-wws-kreditlimit-widget [idktostamm]="customer.idktostamm" />
    <soft-widget-outlet
      [name]="customerDetailOutlet"
      [context]="{ kundennummer: kundennummer(), idktostamm: customer.idktostamm }"
    />
    <soft-offene-posten-widget
      class="customer-detail-wide"
      [idktostamm]="customer.idktostamm"
    />
  </div>
}
